import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import css from './ExtraRow.css';
import Icon from 'SF/MaterialIcon';
import StyledButton from 'common/StyledButton';
import { TextArea } from 'semantic-ui-react';
import useStarfishAPI from "../hooks/useStarfishAPI";
import useError from "../hooks/useError";
import { urlParams } from 'utils/request';

function ExtraRow(props) {
  const [isEditing, setIsEditing] = useState(false);
  const [newDescription, setNewDescription] = useState(props.description);
  const [{success, pending, error}, callAPI] = useStarfishAPI();

  const onSave = () => {
    const URL = `../appointments/saveSelfServiceKioskCheckInDetails.html`;
    callAPI(URL, {
      method: 'POST',
      body: urlParams({
        selfServiceKioskId: props.appointment.selfServiceKioskId, 
        studentId: props.appointment.studentAppointment[0].id, 
        description: newDescription
      }, false)
    });
  };

  // Add error listener
  useError(error, props.setError);

  useEffect(() => {
    if ( success ) {
      setIsEditing(false);
      props.getAppointmentsHistory();
    }
  }, [success])

  const getDescription = () => {
    if ( !isEditing ) return <div className={css['description']} dangerouslySetInnerHTML={{__html: props.description}} />;
    return (
      <div className={css['textarea-container']}>
        <TextArea
          autoFocus
          rows={2}
          autoHeight
          value={newDescription}
          onChange={e => setNewDescription(e.target.value)}
        />
        <div>
          <StyledButton 
            asLink 
            onClick={() => {
              setIsEditing(false);
              setNewDescription(props.description);
            }}>
            Cancel
          </StyledButton>
          <StyledButton
            disabled={pending} 
            onClick={onSave}>
            Save
          </StyledButton>
        </div>
      </div>
    )
  }

  return (
    <tr className={css['selected-bottom-row']}>
      <td colSpan={7}>
        <div className={css['extra-row']}>
          <div>Description</div>
          <div>
            {getDescription()}
            {(props.selfService && !isEditing) && <StyledButton
              onClick={() => setIsEditing(true)} 
              asLink 
              className={css['description-button']}>
              <span>
                <Icon icon="edit" aria-label="Edit description" />
                Edit
              </span>
            </StyledButton>}
          </div>
        </div>
      </td>
    </tr>
  );
}

ExtraRow.propTypes = {  
  selfService: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  getAppointmentsHistory: PropTypes.func.isRequired,
  appointment: PropTypes.object.isRequired,
};

export default ExtraRow;
